{
  "app": {
    "title": "AI Deck",
    "description": "お気に入りの AIツールで、デッキを組む。"
  },
  "nav": {
    "home": "ホーム",
    "services": "サービス",
    "serviceList": "サービス一覧",
    "articles": "記事",
    "favorites": "お気に入り",
    "settings": "ユーザー設定",
    "admin": "管理",
    "adminPanel": "管理画面",
    "adminServices": "サービス管理",
    "adminUsers": "ユーザー管理",
    "adminBanners": "バナー管理",
    "userMenu": "ユーザーメニュー",
    "help": "ヘルプ",
    "legalInfo": "法的情報",
    "mainNavigation": "メインナビゲーション",
    "adminApiKeys": "API キー管理"
  },
  "language": {
    "switch": "言語",
    "en": "English",
    "ja": "日本語",
    "switchToEn": "英語に切り替え",
    "switchToJa": "日本語に切り替え"
  },
  "services": {
    "title": "AIサービス",
    "search": "サービスを検索...",
    "searchNameOnly": "サービス名で検索...",
    "searchWithShortcut": "サービス名、説明等から検索... [{{shortcut}}]",
    "noResults": "サービスが見つかりません",
    "noResultsTitle": "サービスが見つかりませんでした",
    "noResultsDescription": "検索条件を変更してもう一度お試しください。",
    "clearFilters": "フィルターをクリア",
    "addToFavorites": "お気に入りに追加",
    "removeFromFavorites": "お気に入りから削除",
    "hideService": "サービスを非表示",
    "showService": "サービスを表示",
    "resetToDefault": "デフォルトに戻す",
    "clickToOpen": "クリックでサービスを開く",
    "tags": "タグ",
    "favoriteCount": "{{count}}人がお気に入り",
    "clickCount": "{{count}}回クリック",
    "cardActions": "{{name}}の操作",
    "descriptionPopover": "{{name}}の説明を見る",
    "descriptionWithArticle": "{{name}}の説明と解説記事",
    "readArticle": "解説記事を読む",
    "noDescription": "説明はまだ登録されていません。",
    "mcpDocsLink": "{{name}}のMCPドキュメント",
    "deckFavoriteTooltip": "削除 / お気に入り数: {{total}}",
    "deckFavoriteAriaLabel": "お気に入りから削除（お気に入り数: {{total}}）",
    "featured": {
      "title": "注目のサービス",
      "carouselNavigation": "左右矢印キーで操作"
    },
    "badges": {
      "group": "サービス強調タグ",
      "editorPick": "編集者のおすすめサービス",
      "trending": "トレンドサービス",
      "popular": "人気サービス",
      "myService": "マイサービス"
    },
    "addItemDropdown": "アイテム追加",
    "removeLastTag": "タグを 1 個減らす",
    "requestService": "サービスをリクエスト",
    "searching": "検索中",
    "shortcutHint": "{{shortcut}} で素早く検索",
    "searchScope": {
      "nameOnly": "名前のみ",
      "nameOnlyHint": "サービス名・提供元だけを検索（説明文・タグを除く）",
      "nameOnlyAria": "サービス名・提供元だけを検索する",
      "nameOnlyShort": "名前"
    },
    "filteringLabel": "絞り込み中",
    "searchChip": "検索: {{query}}",
    "clearAllFilters": "すべてクリア",
    "filteredCount": "{{count}} / {{total}} 件",
    "removeTagFilterAria": "タグ「{{name}}」の絞り込みを解除",
    "clearSearchAria": "検索キーワードをクリア",
    "loadError": {
      "title": "サービス一覧を読み込めませんでした",
      "description": "ネットワーク接続を確認してから、もう一度お試しください。",
      "retry": "再読み込み"
    },
    "discontinuedBadge": "終了"
  },
  "serviceLinks": {
    "home": "ホーム",
    "document": "ドキュメント",
    "api": "API",
    "changelog": "変更履歴",
    "blog": "ブログ",
    "price": "料金",
    "learn": "学習",
    "faq": "FAQ",
    "github": "GitHub",
    "x": "X (Twitter)",
    "linkedin": "LinkedIn",
    "facebook": "Facebook",
    "instagram": "Instagram",
    "tiktok": "TikTok",
    "discord": "Discord",
    "youtube": "YouTube",
    "productHunt": "Product Hunt"
  },
  "favorites": {
    "title": "My Deck",
    "empty": "お気に入りサービスはまだありません",
    "emptyDescription": "気になるAIツールにハートマークを付けて、お気に入りリストを作成しましょう。",
    "addSome": "ホームページからサービスをお気に入りに追加してください",
    "reorder": "ドラッグで並び替え",
    "dragAndDropHint": "ドラッグ&ドロップで並び替え。左下の図形をクリックでカラー変更",
    "helpButton": "使い方を表示",
    "helpModalTitle": "使い方",
    "helpModalItem1Part1": "サービス一覧でお好みのサービスカードの",
    "helpModalItem1Part2": "をクリックすると、このページに追加されます",
    "helpModalItem2": "をドラッグ&ドロップで並び替えができます",
    "helpModalItem3": "左下の図形アイコンをクリックでカラー変更できます。図形アイコンは設定で非表示にできます。",
    "helpModalItem4": "デッキ追加ボタンで最大10個まで分類できます",
    "helpModalItem5": "デッキ名はクリックで編集できます（頭に絵文字を付ければ見やすい）",
    "helpModalItem6": "をホバー/クリックで、関連リンクやメモ（プライベートメモ含む）を見れます",
    "helpModalItem7": "をクリックで、サービスの詳細情報を編集できます",
    "browseServices": "サービスを探す",
    "addDeck": "デッキを追加",
    "addDeckTitle": "新しいデッキを追加",
    "emptyAreaMessage": "ここにサービスをドラッグ&ドロップ",
    "emptyAreaHint": "(※ デッキ名はクリックで変更できます)",
    "confirmRemove": "お気に入りから削除しますか？",
    "confirmRemoveButton": "削除",
    "confirmCancelButton": "キャンセル"
  },
  "auth": {
    "loginTitle": "ログイン",
    "signupTitle": "アカウント作成",
    "login": "ログイン",
    "logout": "ログアウト",
    "signup": "新規登録",
    "signIn": "サインイン",
    "signingIn": "サインイン中...",
    "createAccount": "アカウント作成",
    "creatingAccount": "アカウント作成中...",
    "email": "メールアドレス",
    "password": "パスワード",
    "confirmPassword": "パスワード（確認）",
    "passwordHint": "8文字以上で入力してください",
    "forgotPassword": "パスワードをお忘れですか？",
    "forgotPasswordTitle": "パスワードリセット",
    "forgotPasswordDescription": "登録済みのメールアドレスを入力してください。パスワードリセット用のリンクをお送りします。",
    "sendResetLink": "リセットリンクを送信",
    "sendingResetLink": "送信中...",
    "resetLinkSent": "リセットリンクを送信しました",
    "resetLinkSentDescription": "メールをご確認ください。パスワードリセット用のリンクをお送りしました。メールが届かない場合は、迷惑メールフォルダをご確認ください。",
    "resetPasswordTitle": "新しいパスワードを設定",
    "newPassword": "新しいパスワード",
    "newPasswordPlaceholder": "8文字以上で入力",
    "confirmNewPassword": "新しいパスワード（確認）",
    "resetPassword": "パスワードを変更",
    "resettingPassword": "変更中...",
    "resetPasswordSuccess": "パスワードを変更しました。新しいパスワードでログインしてください。",
    "invalidResetToken": "無効または期限切れのリセットリンクです。もう一度パスワードリセットをお試しください。",
    "backToLogin": "ログインに戻る",
    "noAccount": "アカウントをお持ちでない方は",
    "hasAccount": "既にアカウントをお持ちの方は",
    "signUpHere": "こちらから登録",
    "loginHere": "こちらからログイン",
    "backToTop": "» トップページに戻る",
    "or": "または",
    "errors": {
      "userAlreadyExists": "このメールアドレスは既に登録されています。ログイン画面からログインしてください。",
      "invalidEmailOrPassword": "メールアドレスまたはパスワードが正しくありません。",
      "emailNotVerified": "メールアドレスの確認が完了していません。受信したリンクをクリックしてください。",
      "passwordTooShort": "パスワードは8文字以上で入力してください。",
      "unknown": "予期しないエラーが発生しました。時間をおいて再度お試しください。"
    }
  },
  "verifyEmail": {
    "verifying": "メールアドレスを認証中...",
    "successTitle": "メール認証完了",
    "successMessage": "メールアドレスの認証が完了しました。",
    "redirectMessage": "3秒後にダッシュボードへ移動します...",
    "goToDashboardNow": "今すぐダッシュボードへ",
    "expiredTitle": "認証リンクの有効期限切れ",
    "expiredMessage": "認証リンクの有効期限が切れています",
    "expiredInstruction": "設定画面から新しい認証メールを再送信してください。",
    "errorTitle": "メール認証エラー",
    "errorDefault": "メール認証に失敗しました",
    "tokenNotFound": "認証トークンが見つかりません",
    "tokenInvalid": "無効な認証トークンです",
    "unexpectedError": "予期しないエラーが発生しました",
    "goToDashboard": "ダッシュボードへ",
    "goToHome": "ホームへ戻る"
  },
  "settings": {
    "title": "設定",
    "description": "アカウントの設定を管理します",
    "tabs": {
      "profile": "プロフィール",
      "security": "セキュリティ",
      "memo": "メモ",
      "plan": "プラン",
      "danger": "アカウント削除",
      "dangerShort": "削除",
      "developer": "API キー"
    },
    "memo": {
      "description": "プライベートメモの暗号化とバックアップ（エクスポート / インポート）を管理します"
    },
    "profile": {
      "title": "プロフィール設定",
      "description": "アカウントの基本情報を編集できます",
      "name": "表示名",
      "namePlaceholder": "山田太郎",
      "nameHelp": "最大20文字",
      "preview": "プレビュー",
      "imageAlt": "プロフィール画像",
      "reset": "リセット",
      "saving": "保存中...",
      "save": "変更を保存",
      "noChanges": "変更なし",
      "noChangesDescription": "変更する項目がありません",
      "saveSuccess": "保存完了",
      "saveSuccessDescription": "プロフィールを更新しました",
      "error": "エラー",
      "errorDescription": "プロフィールの更新に失敗しました",
      "loadError": "プロフィール情報の取得に失敗しました"
    },
    "avatar": {
      "title": "プロフィール画像",
      "description": "6種のスタイルからお選びください",
      "selectStyle": "スタイルを選択",
      "styles": {
        "robot": "ロボット",
        "character": "キャラクター",
        "geometric": "幾何学模様",
        "abstract": "抽象図形",
        "thumbs": "サムネイル",
        "initials": "イニシャル"
      },
      "ariaLabel": {
        "styleButton": "アバタースタイル「{{style}}」を選択",
        "currentStyle": "（現在選択中）"
      }
    },
    "password": {
      "title": "パスワード変更",
      "description": "アカウントのパスワードを変更できます",
      "notice": "パスワード変更後は自動的にログアウトされません。新しいパスワードは次回ログイン時から有効になります。",
      "currentPassword": "現在のパスワード",
      "currentPasswordPlaceholder": "現在のパスワードを入力",
      "newPassword": "新しいパスワード",
      "newPasswordPlaceholder": "新しいパスワードを入力（8文字以上）",
      "newPasswordHelp": "8文字以上128文字以下で入力してください。英数字と記号を組み合わせることを推奨します。",
      "confirmPassword": "新しいパスワード（確認）",
      "confirmPasswordPlaceholder": "新しいパスワードを再入力",
      "reset": "リセット",
      "changing": "変更中...",
      "change": "パスワードを変更",
      "strength": "パスワード強度:",
      "strengthVeryWeak": "非常に弱い",
      "strengthWeak": "弱い",
      "strengthFair": "普通",
      "strengthStrong": "強い",
      "strengthVeryStrong": "非常に強い",
      "changeSuccess": "パスワード変更完了",
      "strengthRecommendation": "パスワード強度の推奨事項",
      "error": "エラー",
      "errorDescription": "パスワード変更に失敗しました",
      "validation": {
        "currentPasswordRequired": "現在のパスワードを入力してください",
        "newPasswordRequired": "新しいパスワードを入力してください",
        "newPasswordTooShort": "パスワードは8文字以上である必要があります",
        "newPasswordTooLong": "パスワードは128文字以下である必要があります",
        "confirmPasswordRequired": "パスワード確認を入力してください",
        "passwordMismatch": "新しいパスワードと確認パスワードが一致しません"
      }
    },
    "security": {
      "title": "セキュリティとアカウント情報",
      "description": "アカウントのセキュリティ設定と情報を確認できます",
      "email": "メールアドレス",
      "changeEmail": "変更",
      "changeEmailTitle": "メールアドレス変更",
      "changeEmailDescription": "新しいメールアドレスを入力してください。変更後、確認メールが送信されます。",
      "currentEmail": "現在のメールアドレス",
      "newEmail": "新しいメールアドレス",
      "newEmailPlaceholder": "new@example.com",
      "cancel": "キャンセル",
      "changing": "変更中...",
      "change": "変更",
      "verified": "認証済み",
      "unverified": "未認証",
      "resendingVerification": "送信中...",
      "resendVerification": "確認メールを再送信",
      "accountInfo": "アカウント情報",
      "userId": "ユーザーID:",
      "role": "権限:",
      "roleAdmin": "管理者",
      "roleUser": "一般ユーザー",
      "status": "アカウント状態:",
      "statusActive": "有効",
      "registeredAt": "登録日時:",
      "lastLogin": "最終ログイン:",
      "totalClicks": "総クリック数:",
      "totalClicksSuffix": "回",
      "lastClickAt": "最終クリック:",
      "none": "なし",
      "inputError": "入力エラー",
      "emailRequired": "新しいメールアドレスを入力してください",
      "emailInvalid": "有効なメールアドレスを入力してください",
      "noChanges": "変更なし",
      "emailSame": "現在と同じメールアドレスです",
      "emailChangeSuccess": "確認メールを送信しました",
      "emailChangeVerificationSent": "新しいメールアドレスに確認メールを送信しました。メール内のリンクをクリックして、変更を完了してください。",
      "error": "エラー",
      "emailChangeError": "メールアドレスの変更に失敗しました",
      "verificationSentSuccess": "確認メール送信",
      "verificationSentError": "確認メール送信に失敗しました",
      "loadError": "セキュリティ情報の取得に失敗しました"
    },
    "plan": {
      "title": "プラン & サブスクリプション",
      "description": "現在のプランの確認とサブスクリプションの管理",
      "currentPlan": "現在のプラン",
      "manageSubscription": "サブスクリプション管理",
      "viewPlans": "プランを見る",
      "upgradeToPro": "Pro にアップグレード",
      "checkoutSuccess": "Pro プランへのアップグレードが完了しました",
      "checkoutSuccessDescription": "ご利用ありがとうございます。全ての Pro 機能をお楽しみください。",
      "portalError": "サブスクリプション管理ページを開けませんでした",
      "portalErrorDescription": "時間をおいて再度お試しください。問題が続く場合はお問い合わせください。"
    },
    "background": {
      "title": "背景設定",
      "colorLabel": "カラー",
      "patternLabel": "パターン",
      "reset": "リセット"
    },
    "backgroundColor": {
      "blue": "ブルー",
      "pink": "ピンク",
      "yellow": "イエロー",
      "green": "グリーン",
      "purple": "パープル",
      "gray": "グレー",
      "midnight": "ミッドナイト",
      "charcoal": "チャコール"
    },
    "backgroundPattern": {
      "title": "背景パターン",
      "none": "なし",
      "dots": "ドット",
      "stripes": "ストライプ",
      "grid": "グリッド",
      "waves": "ウェーブ",
      "checkerboard": "チェック",
      "cross": "クロス"
    },
    "deleteAccount": {
      "title": "アカウント削除",
      "description": "アカウントを完全に削除します。この操作は取り消せません。",
      "subscriptionWarning": {
        "title": "有料プランをご利用中です",
        "description": "アカウントを削除しても、サブスクリプションは自動的にキャンセルされません。削除前に必ずサブスクリプションを解約してください。",
        "manageButton": "サブスクリプション管理"
      },
      "button": "アカウントを削除",
      "confirmTitle": "本当にアカウントを削除しますか？",
      "confirmDescription": "この操作は取り消せません。アカウントとすべてのデータが完全に削除されます。",
      "warning": {
        "title": "警告",
        "dataWillBeDeleted": "以下のデータが完全に削除されます：",
        "accountInfo": "アカウント情報（メールアドレス、パスワード、プロフィール）",
        "favorites": "お気に入り設定",
        "customizations": "カスタマイズ設定（サービス・タグ）",
        "requests": "サービスリクエスト履歴",
        "irreversible": "この操作は取り消せません。"
      },
      "form": {
        "passwordLabel": "パスワードを入力",
        "passwordPlaceholder": "パスワード",
        "confirmationLabel": "確認のため「DELETE」と入力",
        "confirmationPlaceholder": "DELETE",
        "understood": "理解しました。アカウントを削除します。"
      },
      "buttons": {
        "cancel": "キャンセル",
        "deleting": "削除中...",
        "delete": "削除する"
      },
      "toast": {
        "errorTitle": "入力エラー",
        "allFieldsRequired": "全ての項目を入力してください",
        "confirmationMismatch": "'DELETE' と正確に入力してください",
        "successTitle": "アカウントが削除されました",
        "successDescription": "ご利用ありがとうございました",
        "deleteErrorTitle": "削除エラー",
        "deleteErrorDescription": "アカウントの削除に失敗しました"
      }
    },
    "apiKeys": {
      "title": "API キー",
      "description": "公開 API・MCP サーバーにアクセスするためのキーを発行・管理します。",
      "docsLink": "開発者ドキュメントを見る",
      "usage": "{{count}} / {{limit}} 本のキーを使用中",
      "createButton": "キーを作成",
      "limitReached": "キーの上限（{{limit}} 本）に達しています。不要なキーを失効すると新しく作成できます。",
      "upgradeCta": "Pro にアップグレードして上限を増やす",
      "loadError": "API キーの読み込みに失敗しました",
      "empty": "まだ API キーがありません。「キーを作成」から発行できます。",
      "revokedBadge": "失効済み",
      "createdAt": "作成",
      "lastUsed": "最終使用",
      "never": "未使用",
      "revokeButton": "失効",
      "createDialogTitle": "API キーを作成",
      "createDialogDescription": "キーを識別するための名前を付けてください（例: 本番用、開発用）。",
      "nameLabel": "キーの名前",
      "namePlaceholder": "例: 本番用",
      "scopeLabel": "スコープ",
      "scopeRead": "読み取り専用",
      "scopeReadDescription": "カタログの検索・自分のデッキの読み取りができます。",
      "scopeReadWrite": "読み取り + 書き込み",
      "scopeReadWriteDescription": "デッキへの書き込み（サービスの追加・移動）を許可します。MCP の書き込みツールに必要です。",
      "scopeReadBadge": "読み取り",
      "scopeReadWriteBadge": "読み書き",
      "cancel": "キャンセル",
      "create": "作成",
      "creating": "作成中...",
      "createErrorTitle": "作成に失敗しました",
      "createError": "API キーの作成に失敗しました",
      "createdTitle": "API キーを作成しました",
      "createdWarning": "このキーは今だけ表示されます。この画面を閉じると二度と表示されません。安全な場所に保管してください。",
      "copy": "コピー",
      "copyError": "コピーに失敗しました",
      "doneButton": "完了",
      "revokeConfirmTitle": "API キーを失効しますか？",
      "revokeConfirmDescription": "「{{name}}」を失効します。この操作は取り消せません。このキーを使っているアプリはアクセスできなくなります。",
      "revoking": "失効中...",
      "revokeSuccess": "API キーを失効しました",
      "revokeErrorTitle": "失効に失敗しました",
      "revokeError": "API キーの失効に失敗しました"
    }
  },
  "error": {
    "pageTitle": "予期しないエラーが発生しました",
    "pageMessage": "申し訳ありません。問題が発生しました。ページを再読み込みするか、ホームに戻ってください。",
    "sectionTitle": "コンテンツを読み込めません",
    "sectionMessage": "この部分の表示中にエラーが発生しました。",
    "inlineMessage": "エラーが発生しました",
    "retry": "再試行",
    "goHome": "ホームに戻る",
    "showDetails": "詳細を表示（開発者向け）"
  },
  "errorHandler": {
    "network": {
      "title": "接続エラー",
      "description": "ネットワークに接続できません。接続を確認してください。"
    },
    "auth": {
      "title": "認証エラー",
      "description": "セッションが切れました。再度ログインしてください。"
    },
    "validation": {
      "title": "入力エラー",
      "description": "入力内容を確認してください。"
    },
    "server": {
      "title": "サーバーエラー",
      "description": "サーバーで問題が発生しました。しばらくしてから再度お試しください。"
    },
    "rateLimit": {
      "title": "リクエスト制限",
      "description": "リクエストが多すぎます。しばらくしてから再度お試しください。"
    },
    "notFound": {
      "title": "見つかりません",
      "description": "リクエストしたリソースが見つかりませんでした。"
    },
    "unknown": {
      "title": "エラー",
      "description": "予期しないエラーが発生しました。"
    }
  },
  "common": {
    "loading": "読み込み中...",
    "error": "エラーが発生しました",
    "save": "保存",
    "cancel": "キャンセル",
    "delete": "削除",
    "edit": "編集",
    "close": "閉じる",
    "confirm": "確認",
    "back": "戻る",
    "next": "次へ",
    "previous": "前へ",
    "submit": "送信",
    "reset": "リセット"
  },
  "messages": {
    "saveSuccess": "保存しました",
    "saveError": "保存に失敗しました",
    "deleteSuccess": "削除しました",
    "deleteError": "削除に失敗しました",
    "updateSuccess": "更新しました",
    "updateError": "更新に失敗しました"
  },
  "ui": {
    "tags": "タグ",
    "clear": "クリア",
    "tagCategories": {
      "ecosystem": "エコシステム",
      "function": "機能・用途",
      "attribute": "形態・属性"
    },
    "settings": "設定",
    "viewSettings": "表示設定",
    "close": "閉じる",
    "enabled": "有効化",
    "serviceName": "サービス名",
    "cardDesign": "カードデザイン",
    "cardStyleStandard": "スタンダード",
    "cardStyleFlat": "フラット",
    "displayFields": "表示項目",
    "fieldProvider": "プロバイダー",
    "fieldDescription": "説明文",
    "fieldReleaseDate": "リリース日",
    "fieldDevCountry": "開発国",
    "fieldTags": "タグ",
    "presetMinimal": "最小",
    "presetFull": "フル",
    "privateMemoDisplay": "Private Memo表示",
    "privateMemoDisplayDescription": "オフにすると、各サービスのPrivate Memoフィールドが非表示になります",
    "ariaLabelTogglePrivateMemo": "Private Memoの表示切替",
    "colorPickerDisplay": "カラーピッカー表示",
    "colorPickerDisplayDescription": "オフにすると、カードホバー時のみカラーピッカーが表示されます",
    "ariaLabelToggleColorPicker": "カラーピッカーの表示切替",
    "sortBy": "並び替え",
    "sortFavoriteDesc": "人気順",
    "sortCreatedDesc": "追加日の新しい順",
    "sortNameAsc": "名前（A→Z）",
    "sortNameDesc": "名前（Z→A）",
    "ariaLabelCloseSettings": "設定を閉じる",
    "totalServices": "Total",
    "favoriteServices": "お気に入り",
    "customized": "カスタマイズ済み",
    "ariaLabelTotalServices": "全サービス数 {{count}}件",
    "ariaLabelFavoriteServices": "お気に入り {{count}}件",
    "ariaLabelCustomizedServices": "カスタマイズ済み {{count}}件",
    "ariaLabelServiceStats": "サービス統計情報",
    "serviceCounter": "{{current}}/{{total}}",
    "ariaLabelServiceCounter": "現在{{current}}件表示中、全{{total}}件",
    "tagSelected": "{{name}}（選択中）",
    "tagUnselected": "{{name}}（未選択）"
  },
  "admin": {
    "newService": "新規サービス追加",
    "editService": "サービス編集",
    "newServiceDescription": "新しいサービスを追加します。必須項目を入力してください。",
    "editServiceDescription": "サービスの情報を編集します。必須項目を入力してください。"
  },
  "adminBanners": {
    "title": "バナー管理",
    "description": "サービス一覧の上部に表示する横長バナー枠を管理します。ドラッグで並び替えできます。",
    "create": "新規バナー",
    "empty": "バナーがまだありません。「新規バナー」から追加してください。",
    "loading": "バナーを読み込み中",
    "loadError": "バナーの読み込みに失敗しました",
    "columns": {
      "reorder": "並び替え",
      "thumbnail": "サムネイル",
      "alt": "ALT",
      "link": "リンク先",
      "period": "表示期間",
      "status": "状態",
      "active": "有効",
      "actions": "操作"
    },
    "period": {
      "always": "常時",
      "fromOnly": "{{start}} 〜",
      "untilOnly": "〜 {{end}}",
      "range": "{{start}} 〜 {{end}}"
    },
    "status": {
      "active": "配信中",
      "scheduled": "配信前",
      "ended": "終了",
      "disabled": "無効"
    },
    "prBadge": "PR",
    "linkType": {
      "internal": "内部",
      "external": "外部"
    },
    "form": {
      "createTitle": "新規バナー",
      "editTitle": "バナー編集",
      "imageUrl": "画像 URL",
      "imageUrlPlaceholder": "https://images.ai-deck.app/banners/xxxx.webp",
      "imageHint": "推奨 1200×400px（3:1）・WebP・200KB 目安",
      "imagePreviewError": "画像を読み込めません",
      "alt": "ALT（代替テキスト）",
      "altEn": "ALT（英語・任意）",
      "linkUrl": "リンク URL",
      "linkUrlHint": "「/」始まりで内部リンク（例: /services?tags=xxx）、http(s):// で外部リンク",
      "startDate": "開始日",
      "endDate": "終了日",
      "clear": "クリア",
      "isAd": "広告バナー",
      "isAdHint": "ON にすると Pro プランには表示されません（PR バッジを表示）",
      "isActive": "有効",
      "save": "保存",
      "cancel": "キャンセル"
    },
    "actions": {
      "edit": "編集",
      "delete": "削除"
    },
    "deleteConfirm": {
      "title": "バナーを削除しますか？",
      "description": "この操作は取り消せません。バナーを完全に削除します。",
      "confirm": "削除する",
      "cancel": "キャンセル"
    },
    "toast": {
      "created": "バナーを作成しました",
      "updated": "バナーを更新しました",
      "deleted": "バナーを削除しました",
      "activated": "バナーを有効にしました",
      "deactivated": "バナーを無効にしました",
      "reordered": "並び順を保存しました",
      "saveError": "バナーの保存に失敗しました",
      "deleteError": "バナーの削除に失敗しました",
      "toggleError": "状態の変更に失敗しました",
      "reorderError": "並び順の保存に失敗しました",
      "validationError": "入力内容を確認してください"
    }
  },
  "date": {
    "unknown": "日付不明",
    "lessThanHour": "1時間未満",
    "hoursAgo": "{{count}}時間前",
    "daysAgo": "{{count}}日前"
  },
  "privateMemo": {
    "title": "Private Memo",
    "placeholder": "プライベートメモ（{{max}}文字まで）",
    "description": "サーバーに送信されません。データはローカルデバイスに保存されます。",
    "ariaLabel": "プライベートメモ",
    "saving": "保存中...",
    "saved": "保存済み",
    "delete": "プライベートメモを削除",
    "deleteConfirmTitle": "プライベートメモを削除",
    "deleteConfirmDescription": "このプライベートメモを削除してもよろしいですか？この操作は取り消せません。",
    "showMemo": "メモを表示",
    "hiddenMessage": "表示オフになっています。表示するには設定ボタン → Private Memo表示 をオンにしてください",
    "manager": {
      "title": "プライベートメモ管理",
      "currentCountLabel": "現在のメモ数",
      "currentCount": "{{count}}件",
      "exportHeading": "エクスポート",
      "exportDescription": "すべてのプライベートメモをJSONファイルとして保存します",
      "exportButton": "エクスポート",
      "exportEmpty": "メモがありません",
      "importHeading": "インポート",
      "importDescription": "JSONファイルからプライベートメモを復元します",
      "modeLabel": "インポートモード",
      "modeMerge": "マージ（既存を保持）",
      "modeOverwrite": "上書き（既存を削除）",
      "selectFile": "ファイルを選択",
      "importing": "インポート中...",
      "resultSuccessTitle": "インポート完了",
      "resultFailureTitle": "インポート失敗",
      "resultImported": "{{count}}件のメモをインポートしました",
      "resultSkipped": "{{count}}件のメモをスキップしました",
      "resultFailed": "インポートに失敗しました",
      "detailsHeading": "詳細:",
      "skippedItemsLabel": "スキップされた項目 ({{count}}件)",
      "moreCount": "... 他 {{count}}件",
      "errorInvalidId": "不明なサービスID",
      "errorContentSanitized": "不正な文字を除去",
      "errorEmptyAfterSanitize": "サニタイズ後に空になりました",
      "errorTooLong": "文字数オーバー",
      "noticeLabel": "注意:",
      "noticeBody": "プライベートメモはこのデバイスのLocalStorageに保存されており、サーバーには送信されません。エクスポートしたファイルを安全に保管してください。"
    },
    "utils": {
      "fileTooLarge": "ファイルサイズが大きすぎます（最大{{max}}MB）",
      "invalidFormat": "不正なデータ形式です",
      "missingFields": "必須フィールドが不足しています",
      "unsupportedVersion": "非対応のバージョンです: {{version}}",
      "notesNotObject": "notes フィールドはオブジェクトである必要があります",
      "invalidEntry": "不正なメモデータ: {{key}} = {{type}}",
      "tooManyNotes": "メモ件数が多すぎます（最大{{max}}件）",
      "sanitizedNotes": "{{count}}件のメモに不正な文字が含まれていたため除去しました",
      "skippedUnknownIds": "{{count}}件の不明なサービスIDをスキップしました",
      "unknownError": "不明なエラーが発生しました"
    },
    "encryption": {
      "heading": "暗号化",
      "plaintextDescription": "パスフレーズを設定すると、メモは端末内で暗号化して保存されます。各サービスの ID やパスワードのような機密メモの置き場としても使えるようになります。",
      "plaintextNotice": "パスワード等の機密情報は、暗号化を有効にしてから保存してください。",
      "plaintextNoticeAction": "暗号化を設定する",
      "encryptedNotice": "サーバーに送信されません。端末内で暗号化して保存されます。",
      "enableButton": "暗号化を有効にする",
      "enableConfirmButton": "暗号化する",
      "enabling": "暗号化中...",
      "enableError": "暗号化の有効化に失敗しました",
      "passphraseLabel": "パスフレーズ（{{min}}文字以上）",
      "passphraseConfirmLabel": "パスフレーズ（確認）",
      "passphrasePlaceholder": "パスフレーズ",
      "forgotWarning": "パスフレーズを忘れると復旧できません。その場合は全メモの削除（リセット）しか手段がなくなります。パスフレーズは安全な場所に保管してください。",
      "tooShort": "パスフレーズは{{min}}文字以上で入力してください",
      "mismatch": "パスフレーズが一致しません",
      "lockedStatus": "ロック中",
      "lockedMessage": "メモは暗号化されています。パスフレーズを入力して解除してください。",
      "unlockButton": "解除",
      "unlocking": "解除中...",
      "wrongPassphrase": "パスフレーズが違います",
      "enabledStatus": "暗号化は有効です（ロック解除済み）",
      "disableButton": "暗号化を無効にする",
      "disableConfirmTitle": "暗号化を無効にしますか？",
      "disableConfirmDescription": "メモは暗号化なしの保存に戻ります。パスワード等の機密メモを残している場合は、先に削除することをおすすめします。",
      "disableConfirmButton": "無効にする",
      "resetButton": "リセット（全メモ削除）",
      "resetConfirmTitle": "全メモを削除しますか？",
      "resetConfirmDescription": "すべてのプライベートメモを削除し、暗号化を解除します。この操作は取り消せません。パスフレーズを忘れた場合の唯一の復旧手段です。",
      "exportEncryptedDescription": "暗号化されたまま書き出します。取り込みには作成時のパスフレーズが必要です。",
      "exportEncryptedButton": "暗号化バックアップをエクスポート",
      "exportPlainButton": "暗号化なしでエクスポート",
      "exportPlainConfirmTitle": "暗号化なしでエクスポートしますか？",
      "exportPlainConfirmDescription": "書き出されるファイルは暗号化されません。機密メモが含まれる場合は、ファイルの取り扱いに注意してください。",
      "exportPlainConfirmButton": "エクスポート",
      "importLockedMessage": "ロック中はインポートできません。先にロックを解除してください。",
      "importPassphraseLabel": "バックアップのパスフレーズ",
      "importEncryptedDetected": "暗号化バックアップが選択されました。作成時のパスフレーズを入力してください。",
      "importDecryptButton": "復号して取り込む",
      "nudgeTitle": "プライベートメモを暗号化しますか？",
      "nudgeTradeoffs": "ご注意: パスフレーズを忘れるとメモは復旧できず、全削除しか手段がなくなります。また、ページを開き直すたびに解除の入力が必要になります。暗号化はあとから設定ページの「メモ」タブでいつでも設定・解除できます。",
      "nudgeLater": "今はしない"
    }
  },
  "memo": {
    "title": "Memo"
  },
  "countries": {
    "US": "アメリカ合衆国",
    "CN": "中国",
    "GB": "イギリス",
    "IL": "イスラエル",
    "CA": "カナダ",
    "FR": "フランス",
    "IN": "インド",
    "JP": "日本",
    "DE": "ドイツ",
    "SG": "シンガポール",
    "KR": "韓国",
    "AU": "オーストラリア",
    "CH": "スイス",
    "SE": "スウェーデン",
    "AE": "アラブ首長国連邦（UAE）"
  },
  "pages": {
    "userGuide": "ご利用ガイド",
    "pricing": "料金",
    "faq": "FAQ",
    "changelog": "変更履歴",
    "feedback": "お問い合わせ",
    "developers": "開発者向け API",
    "archive": {
      "title": "終了したサービス",
      "metaDescription": "提供を終了した AI サービスの記録です。終了日と終了時点の説明文を残しています。",
      "lead": "提供を終了した AI サービスの記録です。ここに掲載されたサービスは掲載総数には含まれませんが、どのようなサービスがあったかを後から辿れるよう、終了時点の情報を記録として残しています。",
      "discontinuedOn": "{{date}} に提供終了",
      "source": "出典",
      "article": "解説記事",
      "empty": "終了したサービスはまだありません。",
      "error": "終了したサービスの一覧を読み込めませんでした。時間をおいて再度お試しください。"
    }
  },
  "legal": {
    "title": "法務",
    "terms": "利用規約",
    "privacy": "プライバシーポリシー",
    "commercial": "特定商取引法に基づく表記",
    "sellerInfo": "販売者情報",
    "refund": "返金・キャンセルポリシー",
    "lastUpdated": "最終更新日: {{date}}",
    "japaneseVersionNote": "本規約は日本語版を正文とします。英語版は参考訳です。"
  },
  "footer": {
    "terms": "利用規約",
    "privacy": "プライバシー",
    "sellerInfo": "特商法表記"
  },
  "serviceEdit": {
    "title": "サービス編集",
    "backToList": "← 一覧に戻る",
    "created": "作成",
    "updated": "更新",
    "description": "説明",
    "descriptionRequired": "説明は必須です",
    "serviceUrl": "サービスURL",
    "serviceUrlRequired": "有効なURLを入力してください",
    "devCountry": "開発国",
    "devCountryPlaceholder": "例: USA, Japan, China",
    "personalNotes": "自分のメモ",
    "personalNotesMarkdown": "Markdown形式で入力",
    "personalNotesPlaceholder": "- [リンク](URL)\n- メモ\n- タスク",
    "personalNotesMaxLength": "メモは500文字以内で入力してください",
    "personalNotesCharCount": "{{count}}/500 文字",
    "defaultMemoTitle": "📌 デフォルトメモを表示",
    "tags": "タグ",
    "saving": "保存中...",
    "save": "💾 保存",
    "cancel": "✕ キャンセル",
    "customized": "Customized",
    "resetButton": "リセット",
    "resetDialogTitle": "デフォルト設定に戻しますか？",
    "resetDialogDescription": "このサービスのすべてのカスタマイズ（説明、料金情報、モデル、URL、API URL、自分のメモ、タグ等）がリセットされ、デフォルト設定に戻ります。\nデフォルトメモ（組織レベル）は削除されません。\nこの操作は取り消せません。",
    "resetDialogCancel": "キャンセル",
    "resetting": "リセット中...",
    "resetDialogConfirm": "リセット",
    "notFound": "サービスが見つかりません",
    "notFoundDescription": "指定されたサービスIDのサービスは存在しないか、\nアクセス権限がない可能性があります。",
    "backToServices": "サービス一覧に戻る",
    "saveSuccess": "保存しました",
    "saveSuccessDescription": "サービス情報が正常に更新されました",
    "saveError": "保存に失敗しました",
    "resetSuccess": "リセット完了",
    "resetSuccessDescription": "デフォルト設定に戻しました",
    "resetError": "デフォルト設定への復元に失敗しました",
    "requiredField": "*",
    "ariaLabelResetToDefault": "デフォルト設定に戻す",
    "ariaLabelOpenServiceUrl": "サービスURLを開く"
  },
  "planGate": {
    "editRequiresPro": "アイテムの編集は Pro プランの機能です",
    "editRequiresProDescription": "Pro プランにアップグレードすると、サービス情報の編集やメモの保存ができるようになります。",
    "viewPricing": "料金プランを見る"
  },
  "userService": {
    "addButton": "マイアイテム追加",
    "addTitle": "マイサービスを追加",
    "addDescription": "プライベートなサービスを追加（残り{{remaining}}/{{max}}件）",
    "editTitle": "マイサービスを編集",
    "editDescription": "プライベートサービスの情報を編集",
    "name": "サービス名",
    "namePlaceholder": "例: My ChatGPT Custom",
    "nameRequired": "サービス名は必須です",
    "url": "URL",
    "urlInvalid": "有効なURLを入力してください",
    "provider": "提供者",
    "providerPlaceholder": "例: OpenAI",
    "logoUrl": "ロゴURL",
    "logoUrlInvalid": "有効なURLを入力してください",
    "description": "説明",
    "descriptionPlaceholder": "サービスの簡単な説明",
    "releaseDate": "リリース日",
    "devCountry": "国コード",
    "devCountryPlaceholder": "例: US, JP",
    "personalNotes": "メモ",
    "personalNotesPlaceholder": "このサービスについてのプライベートメモ",
    "notesMaxLength": "メモは500文字以内で入力してください",
    "tags": "タグ",
    "save": "保存",
    "saving": "保存中...",
    "cancel": "キャンセル",
    "delete": "削除",
    "deleting": "削除中...",
    "createSuccess": "サービスを追加しました",
    "createSuccessDescription": "マイサービスが正常に追加されました",
    "updateSuccess": "サービスを更新しました",
    "updateSuccessDescription": "マイサービスが正常に更新されました",
    "deleteSuccess": "サービスを削除しました",
    "deleteSuccessDescription": "マイサービスが削除されました",
    "saveError": "サービスの保存に失敗しました",
    "deleteError": "サービスの削除に失敗しました",
    "deleteDialogTitle": "サービスを削除しますか？",
    "deleteDialogDescription": "「{{name}}」を削除してもよろしいですか？この操作は取り消せません。",
    "deleteDialogCancel": "キャンセル",
    "deleteDialogConfirm": "削除",
    "limitReached": "サービスの上限数（{{max}}件）に達しています",
    "badge": "マイサービス"
  },
  "cookieConsent": {
    "banner": {
      "title": "Cookie使用のお知らせ",
      "description": "当サイトはサービス提供のため必須Cookieを使用します。詳細設定で分析・広告Cookieの選択も可能です。",
      "privacyPolicyLink": "プライバシーポリシー",
      "rejectAll": "全て拒否",
      "rejectAllAria": "必須Cookie以外を全て拒否",
      "preferences": "詳細設定",
      "preferencesAria": "Cookie詳細設定を開く",
      "acceptAll": "全て許可",
      "acceptAllAria": "全てのCookieを許可"
    },
    "preferences": {
      "title": "Cookie設定",
      "description": "カテゴリごとにCookieの使用を管理できます。",
      "required": "必須",
      "examplesPrefix": "例: ",
      "privacyPolicyLink": "プライバシーポリシー",
      "rejectAll": "全て拒否",
      "saveSelection": "選択を保存",
      "acceptAll": "全て許可"
    },
    "categories": {
      "essential": {
        "name": "必須Cookie",
        "description": "サイトの基本機能（ログイン、セキュリティ）に必須です。"
      },
      "functional": {
        "name": "機能的Cookie",
        "description": "あなたの設定（言語、テーマ等）を記憶します。"
      },
      "analytics": {
        "name": "分析Cookie",
        "description": "匿名でサイト利用状況を分析し、改善に役立てます。"
      },
      "advertising": {
        "name": "広告Cookie",
        "description": "ターゲティング広告、アフィリエイト追跡に使用されます。"
      }
    },
    "settings": {
      "buttonAria": "Cookie設定を開く"
    }
  },
  "accessibility": {
    "skipToMain": "メインコンテンツへスキップ"
  },
  "swrError": {
    "title": "エラーが発生しました",
    "networkMessage": "ネットワークに接続できません",
    "defaultMessage": "データの読み込みに失敗しました",
    "retry": "再試行"
  },
  "landing": {
    "header": {
      "features": "機能",
      "pricing": "料金",
      "faq": "FAQ",
      "login": "ログイン",
      "getStartedFree": "無料で始める",
      "openMenu": "メニューを開く",
      "desktopNav": "メインナビゲーション",
      "mobileNav": "モバイルナビゲーション",
      "goToDashboard": "ダッシュボード",
      "themeToLight": "ライトモードに切替",
      "themeToDark": "ダークモードに切替"
    },
    "hero": {
      "badge": "AIツール管理アプリ",
      "titleLine1": "お気に入りの AIツールで、",
      "titleLine2": "デッキを組む。",
      "subtitle": "「あのツールどこだっけ？」をなくします。",
      "getStartedFree": "無料で始める",
      "login": "ログイン",
      "servicesCount": "630+",
      "servicesRegistered": "AIサービス登録済み",
      "screenshotAlt": "AI Deck アプリケーション画面",
      "signupNote": "登録はメールまたは Google / GitHub で、約 30 秒で完了します"
    },
    "latestArticles": {
      "title": "最近追加された AIツール・サービス",
      "subtitle": "新着サービスの解説記事から、気になるツールをチェック。",
      "viewAll": "解説記事をもっと見る"
    },
    "campaign": {
      "banner": "🎁 リリース記念: 8/19 までにキャンペーン投稿を RT + 登録で、Pro 機能が永年無料（※広告非表示のみ対象外）"
    },
    "features": {
      "titleLine1": "充実の機能で、",
      "titleLine2": "AIツールを快適に管理",
      "subtitleLine1": "検索・整理・カスタマイズ。",
      "subtitleLine2": "あなたに必要な機能が揃っています。",
      "search": {
        "title": "{{servicesCount}} から、瞬時に見つかる",
        "description": "キーワードとタグの絞り込みで、目的の AIサービスに最短で辿り着く。新サービスも随時追加。",
        "imageAlt": "AI Deck のサービス一覧画面"
      },
      "links": {
        "title": "公式情報へ、1 クリック",
        "description": "ホバーだけで関連リンクを一覧表示。ドキュメント・料金・SNS・API へ直行できます。",
        "imageAlt": "ホバーで開く関連リンクのポップアップ画面"
      },
      "colors": {
        "title": "グループ × 7 色ラベル",
        "description": "用途ごとに整理して、色でパッと識別。並びはドラッグで自由自在。",
        "imageAlt": "グループと色ラベルで整理されたデッキ画面"
      },
      "views": {
        "title": "3 種類のビュー切替",
        "description": "ミニマム・コンパクト・フル。密度を切り替えて快適に閲覧。",
        "viewMinimal": "ミニマム",
        "viewCompact": "コンパクト",
        "viewFull": "フル"
      },
      "memo": {
        "title": "プライベートメモ",
        "description": "DB に保存されないローカル完結。自分だけの情報を安全に記録。",
        "memoLabel": "自分だけのメモ"
      },
      "customize": {
        "title": "デッキを、自分仕様に",
        "description": "独自サービスの追加も、既存サービスの内容編集も。カタログにない社内ツールまで、1 枚のデッキに。",
        "fieldName": "サービス名",
        "sampleName": "社内 GPT ラボ"
      }
    },
    "benefits": {
      "eyebrow": "こんなお悩み、ありませんか？",
      "title": "AI Deckが解決します！",
      "subtitle": "ブラウザのブックマーク管理よりも快適・便利！",
      "item0": {
        "problem": "AIツールが多すぎて、どれを使えばいいか分からない",
        "solution": "キーワード検索とタグ絞り込みで、目的のサービスが瞬時に見つかる。",
        "imageAlt": "たくさんのカードの中から虫眼鏡で 1 枚を見つけ出すイラスト"
      },
      "item1": {
        "problem": "AIサービスのポータルサイトはマイ管理には不向き",
        "solution": "優れた一覧性でサービスを快適に閲覧。見やすく整理された画面。",
        "imageAlt": "色ラベル付きのカードが整然と並ぶイラスト"
      },
      "item2": {
        "problem": "ブラウザのブックマークが増え過ぎて探しづらい",
        "solution": "よく使うツールをお気に入り登録。ワンクリックでアクセス。",
        "imageAlt": "ハートマーク付きのカードが手札のように並ぶイラスト"
      },
      "item3": {
        "problem": "それぞれのサービスがどんなだったかを忘れてしまう",
        "solution": "サービスロゴにホバーで概要が出る。自分用のメモも追加できる。",
        "imageAlt": "カードに付箋とペンを添えたイラスト"
      }
    },
    "howItWorks": {
      "title": "使い方は超簡単！",
      "subtitle": "シンプルな操作で、あなた専用のAIデッキが組めます。",
      "cta": "無料でデッキを組んでみる",
      "ctaNote": "¥0 で今すぐ開始 ─ {{servicesCount}} のサービスから、あなたの一軍を。",
      "memoLabel": "メモ",
      "proChip": "PRO で編集も",
      "step0": {
        "title": "好きなサービスをお気に入りに登録",
        "description": "サービス一覧ページで、デッキに登録したいものにハートを付けお気に入り登録。"
      },
      "step1": {
        "title": "お好みに並び替え＆グループ化",
        "description": "ドラッグ＆ドロップで直感的に並び替え。グループ化や色ラベルで識別しやすく。"
      },
      "step2": {
        "title": "メモの追加、内容の編集",
        "description": "プライベートメモを記入できる。有料版はサービス追加や内容のカスタマイズも可能。"
      }
    },
    "pricing": {
      "title": "料金プラン",
      "subtitleLine1": "無料プランでも十分便利に使えます。",
      "subtitleLine2": "今すぐアカウントを作成して、AIデッキを構築しましょう！",
      "recommendedBadge": "まずはこちら",
      "freePlan": "無料プラン",
      "proPlan": "Proプラン",
      "freePlanPrice": "¥0",
      "noCreditCard": "クレジットカード登録不要",
      "monthlyBilling": "月払い",
      "yearlyBilling": "年払い",
      "perMonth": "/月",
      "yearlyTotal": "年間 {{price}}",
      "yearlySavings": "{{months}}ヶ月分お得",
      "monthlyTotal": "月額課金（年間 {{price}}）",
      "createFreeAccount": "無料アカウントを作成",
      "startProPlan": "Proプランを始める",
      "startProPlanMonthly": "Proプラン（月払い）を始める",
      "startProPlanYearly": "Proプラン（年払い）を始める",
      "freeFeatures": {
        "item0": "多くのAIツール・サービスへのアクセス",
        "item1": "グループ化・カラー識別",
        "item2": "高速検索・タグ絞り込み",
        "item3": "プライベートメモ",
        "item4": "追加・編集は不可"
      },
      "proFeatures": {
        "item0": "無料プランの全機能",
        "item1": "マイアイテム追加機能",
        "item2": "既存アイテム編集機能",
        "item3": "広告非表示機能",
        "item4": "優先サポート",
        "item5": "今後追加される全ての新機能"
      },
      "yearlyPriceNote": "年払いの場合（月あたり換算）",
      "monthlyPriceNote": "月払いの場合"
    },
    "developers": {
      "title": "API と MCP で、外からも使える",
      "subtitle": "AI Deck はアプリの中だけで完結しません。読み取り専用の公開 API と MCP サーバーを標準装備 ─ Claude や ChatGPT、主要なコーディングエージェントから MCP で繋いで、カタログ検索・サービス推薦をそのまま呼び出せます。API キーなしでも試せます。",
      "clientsMore": "+ MCP 対応クライアント",
      "terminalTitle": "AI エージェント",
      "terminalPrompt": "動画生成の定番を、私のデッキから推薦して",
      "terminalRunning": "ai-deck: recommend_services を実行中…",
      "terminalDone": "カタログからおすすめを 3 件返答",
      "cta": "開発者向けドキュメントを見る"
    },
    "faq": {
      "title": "よくある質問",
      "item0": {
        "question": "AI Deckは本当に無料ですか？",
        "answer": "はい、完全無料でご利用いただけます。クレジットカードの登録も不要です。"
      },
      "item1": {
        "question": "どのようなAIサービスが登録されていますか？",
        "answer": "有名どころはもちろん、マイナーなものまで、多くの AIに関連するサービスが登録されています。今後も定期的に追加予定です。追加希望のサービスやツールがあれば、登録申請フォームからご要望ください。"
      },
      "item2": {
        "question": "データは安全に保管されますか？",
        "answer": "はい。安全に保管されます。あなたのカスタマイズ情報は他のユーザーに共有されることはありません。「プライベートメモ」は、あなたのデバイス上に保存されるので、サーバーに記録されることさえありません。"
      },
      "item3": {
        "question": "スマートフォンでも使えますか？",
        "answer": "はい。AI Deckはレスポンシブデザインを採用しており、スマートフォン、タブレットでもご利用いただけます。ただし、PCで最も快適に使えるよう設計されています。"
      },
      "item4": {
        "question": "アカウント削除はできますか？",
        "answer": "はい、いつでもアカウントを削除できます。設定画面から簡単に削除できます。"
      }
    },
    "finalCta": {
      "titleLine1": "あなた専用のAIデッキを",
      "titleLine2": "今すぐ作りましょう",
      "subtitle": "無料プランでも十分便利に使えます！",
      "cta": "今すぐデッキを作る"
    },
    "footer": {
      "description": "お気に入りの AIツールで、デッキを組むプラットフォーム",
      "product": "プロダクト",
      "freeSignup": "無料登録",
      "login": "ログイン",
      "pricing": "料金",
      "changelog": "変更履歴",
      "support": "サポート",
      "userGuide": "ご利用ガイド",
      "faq": "よくある質問",
      "contact": "お問い合わせ",
      "legal": "規約とポリシー",
      "terms": "利用規約",
      "privacy": "プライバシーポリシー",
      "commercial": "特定商取引法に基づく表記",
      "refund": "返金・キャンセルポリシー",
      "developers": "開発者向け API"
    },
    "pricingPage": {
      "heroTitle": "料金プラン",
      "heroSubtitleLine1": "無料プランでも十分便利に使えます。",
      "heroSubtitleLine2": "Proプランでさらに快適なAI管理を。",
      "recommendedBadge": "まずはこちら",
      "freePlan": "無料プラン",
      "proPlan": "Proプラン",
      "noCreditCard": "クレジットカード登録不要",
      "getStartedFree": "無料で始める",
      "startProPlan": "Proプランを始める",
      "startProPlanMonthly": "Proプラン（月払い）を始める",
      "startProPlanYearly": "Proプラン（年払い）を始める",
      "comparisonTitle": "機能比較表",
      "feature": "機能",
      "comparisonFeatures": {
        "item0": "AIサービスの検索・閲覧・デッキ登録",
        "item1": "お気に入り登録",
        "item2": "最大デッキ数（グループ数）",
        "item3": "検索・フィルター",
        "item4": "カラー識別",
        "item5": "プライベートメモ",
        "item6": "広告非表示",
        "item7": "各アイテムのカスタマイズ（URL・説明文・メモ）",
        "item8": "タグの編集",
        "item9": "優先サポート"
      },
      "comparisonValues": {
        "unlimited": "無制限",
        "maxDecks": "最大10個"
      },
      "campaignProNote": "※ 過去のキャンペーンで配布された特別プランをご利用の方は、広告表示はありますが Pro と同等の全機能をお使いいただけます。",
      "paymentTitle": "お支払い方法",
      "paymentItems": {
        "item0": "クレジットカード（Visa, Mastercard, JCB, American Express）",
        "item1": "デビットカード",
        "item2": "※ 決済は Polar Software, Inc. を通じて安全に処理されます"
      },
      "securityTitle": "セキュリティ",
      "securityItems": {
        "item0": "SSL暗号化通信",
        "item1": "カード情報は決済代行会社が安全に管理",
        "item2": "当社ではカード情報を保持しません"
      },
      "cancellationTitle": "解約・返金について",
      "cancellationItems": {
        "item0": "いつでも解約可能",
        "item1": "解約後も期間終了まで利用可能",
        "item2": "返金ポリシーの詳細は下記リンクから"
      },
      "cancellationLink": "返金ポリシーを見る",
      "contactTitle": "お問い合わせ",
      "contactItems": {
        "item0": "料金に関するご質問はお気軽に",
        "item1": "フィードバックページからご連絡ください"
      },
      "contactLink": "お問い合わせはこちら",
      "faqTitle": "料金に関するよくある質問",
      "faq": {
        "item0": {
          "question": "無料プランと有料プランの違いは何ですか？",
          "answer": "無料プランでは基本的な機能（サービス閲覧、お気に入り登録、検索など）をすべてご利用いただけます。Proプランでは広告非表示、各アイテムのカスタマイズ（URL・説明文・メモ）、優先サポートなどの追加機能をご利用いただけます。"
        },
        "item1": {
          "question": "年払いと月払いはどちらがお得ですか？",
          "answer": "年払いの場合、月あたり約¥225（年間¥2,700）となり、月払い（¥300/月 × 12ヶ月 = ¥3,600）と比較して3ヶ月分お得です。"
        },
        "item2": {
          "question": "支払い方法は何が使えますか？",
          "answer": "クレジットカード（Visa, Mastercard, JCB, American Express）およびデビットカードがご利用いただけます。決済は Polar Software, Inc. を通じて安全に処理されます。"
        },
        "item3": {
          "question": "解約はいつでもできますか？",
          "answer": "はい、いつでも解約可能です。解約後も契約期間終了までProプランの機能をご利用いただけます。"
        }
      },
      "viewAllFaq": "すべてのFAQを見る →",
      "ctaTitle": "まずは無料で始めてみませんか？",
      "ctaSubtitleLine1": "クレジットカード不要で今すぐスタート。",
      "ctaSubtitleLine2": "Proプランへのアップグレードはいつでも可能です。",
      "ctaUpgradeTitle": "Proプランにアップグレードしませんか？",
      "ctaUpgradeSubtitleLine1": "自分だけのAIツールを自由に追加・編集できます。",
      "ctaUpgradeSubtitleLine2": "広告非表示や優先サポートなど、すべてのPro機能が使い放題。",
      "ctaProTitle": "Proプランをご利用いただきありがとうございます",
      "ctaProSubtitle": "すべてのPro機能をお楽しみください。",
      "manageSubscription": "サブスクリプションを管理",
      "currentPlan": "現在のプラン",
      "billingError": "決済ページを開けませんでした",
      "billingErrorDescription": "時間をおいて再度お試しください。問題が続く場合はお問い合わせください。",
      "ctaButton": "無料で始める",
      "backToHome": "← ホームに戻る"
    }
  },
  "publishDeck": {
    "titleNew": "デッキを公開する",
    "titleEditing": "公開中のデッキ",
    "subtitleNew": "現在のデッキを SNS でシェア可能な URL として公開します。",
    "subtitleEditing": "公開設定を変更して再公開できます。設定変更後に「更新して公開」を押してください。",
    "devWarningTitle": "⚠️ 開発環境のため、この URL は本番デプロイ後にアクセスできます",
    "devWarningHint": "ローカルで表示確認するには <1>{{url}}</1> を直接開いてください。",
    "publicUrlLabel": "公開 URL",
    "shareButton": "シェア",
    "copyUrlButton": "URL をコピー",
    "settingsLegend": "公開設定",
    "includeNotesLabel": "個人メモを含める",
    "includeNotesDescription": "各サービスに書いた自分用メモが公開ページに表示されます",
    "includeUserOwnedLabel": "マイサービスを含める",
    "includeUserOwnedDescription": "自分で追加したマイサービスが公開ページに表示されます",
    "affiliateNoteTitle": "リンク先について",
    "affiliateNoteFree": "公開ページのカードのリンク先は、一部サービスでアフィリエイトリンクになります（無料プラン・永年 Pro プランが対象）。Pro プランでは公式サイトの URL のままになります。",
    "titleLabel": "タイトル（任意）",
    "titlePlaceholder": "私の AI デッキ",
    "descriptionLabel": "説明（任意）",
    "descriptionPlaceholder": "このデッキの紹介文",
    "unpublishButton": "公開を取り下げる",
    "publishButton": "公開する",
    "updatePublishButton": "更新して公開",
    "shareTitle": "私の AI デッキ",
    "shareText": "私の AI デッキを公開しました",
    "toast": {
      "errorTitle": "エラー",
      "publishSuccessTitle": "デッキを公開しました",
      "updateSuccessTitle": "公開を更新しました",
      "publishSuccessDescription": "URL をシェアしてみんなに見てもらいましょう",
      "publishErrorDefault": "公開に失敗しました",
      "unpublishSuccessTitle": "公開を取り下げました",
      "unpublishSuccessDescription": "URL は再公開すると復活します",
      "unpublishErrorDefault": "取り下げに失敗しました",
      "copySuccess": "URL をコピーしました",
      "copyErrorTitle": "URL のコピーに失敗しました",
      "copyErrorDescription": "ブラウザの権限設定をご確認ください"
    },
    "unpublishDialog": {
      "title": "公開を取り下げますか？",
      "description": "SNS でシェアされている URL は一時的にアクセスできなくなります。再公開すれば同じ URL で復活します。",
      "cancel": "キャンセル",
      "confirm": "取り下げる"
    }
  },
  "publicDeck": {
    "defaultTitle": "{{name}} の AI デッキ",
    "anonymous": "匿名ユーザー",
    "metaDescription": "{{count}} 個の AI サービスをまとめたデッキ",
    "serviceCount": "{{count}} サービス",
    "areaCount": "{{count}} エリア",
    "updatedOn": "{{date}} 更新",
    "areaNavLabel": "エリア一覧",
    "viewToggleLabel": "表示形式",
    "viewCard": "カード",
    "viewList": "リスト",
    "areaFallback": "エリア {{area}}",
    "otherArea": "その他",
    "empty": "このデッキには公開されたサービスがありません",
    "openService": "{{name}} を開く",
    "readMore": "続きを読む",
    "showLess": "閉じる",
    "officialNote": "公式ノート",
    "ownerNote": "公開者のメモ",
    "moreTags": "他 {{count}} 件のタグ",
    "loading": "公開デッキを読み込み中",
    "errorTitle": "読み込みエラー",
    "errorMessage": "デッキの取得に失敗しました。時間をおいて再度お試しください。",
    "notFoundTitle": "このデッキは公開されていません",
    "notFoundMessage": "URL が間違っているか、所有者によって公開が取り下げられた可能性があります。",
    "backHome": "{{site}} ホームへ",
    "poweredBy": "Powered by {{site}}",
    "cta": "あなたの AI デッキを作る",
    "topNavCta": "自分のデッキを作る →"
  },
  "serviceRequest": {
    "title": "サービス追加リクエスト",
    "description": "追加してほしいAIサービスをリクエストできます",
    "triggerButton": "アイテム追加申請",
    "serviceName": "サービス名",
    "serviceNamePlaceholder": "例: ChatGPT、Claude など",
    "serviceUrl": "サービスURL",
    "descriptionLabel": "サービスの説明",
    "descriptionPlaceholder": "このサービスがどのようなものか簡潔に説明してください",
    "descriptionRequired": "説明は必須です",
    "reasoning": "備考（任意）",
    "reasoningPlaceholder": "その他の情報があれば",
    "categorySuggestion": "推奨カテゴリ（タグ）",
    "nameRequired": "サービス名は必須です",
    "urlInvalid": "有効なURLを入力してください",
    "submit": "リクエストを送信",
    "submitting": "送信中...",
    "cancel": "キャンセル",
    "submitSuccess": "送信完了",
    "submitSuccessDescription": "サービス追加リクエストを送信しました。管理者のレビューをお待ちください。",
    "submitError": "送信エラー",
    "unknownError": "不明なエラーが発生しました",
    "duplicateError": "重複エラー",
    "existingService": "登録済みサービス",
    "existingRequest": "申請中",
    "noDuplicate": "このURLは登録されていません",
    "rateLimitInfo": "残り送信可能回数: {{remaining}}/{{limit}}",
    "rateLimitExceeded": "送信回数の上限に達しました。1時間後に再度お試しください。",
    "checking": "チェック中..."
  },
  "tour": {
    "buttons": {
      "next": "次へ",
      "prev": "戻る",
      "done": "完了"
    },
    "progressText": "ステップ {{current}} / {{total}}",
    "restart": "ツアーをもう一度見る",
    "restartTooltip": "ガイドツアーを最初から再生します",
    "deck": {
      "welcome": {
        "title": "AI Deck へようこそ",
        "body": "お気に入りの AIツールで、デッキを組む。30 秒で主な機能をご案内します。"
      },
      "addService": {
        "title": "サービス一覧から追加",
        "body": "メインメニューの『サービス一覧』から AI サービスを探して追加できます。あなた独自のサービスも最大 100 件まで登録可能です。"
      },
      "favorite": {
        "title": "お気に入り",
        "body": "ハートアイコンでお気に入り登録。登録したサービスはホームのデッキに自動表示されます。"
      },
      "tagFilter": {
        "title": "タグで絞り込み",
        "body": "用途や分野でタグを選択し、サービスを絞り込めます。複数タグの組み合わせも可能です。"
      },
      "search": {
        "title": "検索",
        "body": "サービス名・説明・タグから横断検索。キーボードショートカットでもすぐに開けます。"
      },
      "serviceLogo": {
        "title": "ロゴにホバーで概要",
        "body": "サービスのロゴにマウスを乗せる(モバイルではタップ)と、サービスの概要が表示されます。"
      },
      "serviceMemo": {
        "title": "リストアイコンでリンク・メモ",
        "body": "リストアイコンにマウスを乗せる(モバイルではタップ)と、公式サイトへのリンクや個人メモを確認できます。"
      },
      "dnd": {
        "title": "ドラッグで並び替え",
        "body": "デッキ上のカードはドラッグで並び替え可能。よく使う順に並べておくと便利です。"
      },
      "userMenu": {
        "title": "メニューはここから",
        "body": "ユーザー設定や「ツアーをもう一度見る」はこのメニューから。困ったらここを開いてください。"
      }
    },
    "pro": {
      "welcome": {
        "title": "Pro プランへようこそ",
        "body": "Pro プラン特典をかんたんにご案内します。30 秒だけお時間をください。"
      },
      "adFree": {
        "title": "広告が非表示に",
        "body": "Pro プランでは広告が完全に非表示になります。デッキを集中して使えます。"
      },
      "userServices": {
        "title": "独自サービスを最大 100 件",
        "body": "あなた専用のサービスを最大 100 件登録可能。社内ツールやニッチな AI も自分だけのデッキに整理できます。"
      },
      "portal": {
        "title": "プラン管理はここから",
        "body": "請求情報・領収書の確認・解約はユーザー設定の請求セクションからいつでも操作できます。"
      }
    }
  },
  "developers": {
    "heroTitle": "開発者向け API",
    "heroSubtitle": "{{appName}} の AI サービスカタログを、あなたのアプリやエージェントから利用できます。",
    "copy": "コピー",
    "overview": {
      "title": "概要",
      "body": "{{appName}} 公開 API は、読み取り専用の AI サービスカタログ API です。サービス一覧・詳細・タグ・公開デッキ・統計を JSON で取得できます。書き込みや個人データへのアクセスはできません。",
      "attribution": "API から取得したデータを表示する際は、{{appName}}（https://ai-deck.app）へのリンクによるクレジット表記（attribution）が必須です。各レスポンスに aiDeckUrl と attribution フィールドが含まれます。"
    },
    "urlNote": "サービスの url フィールドはプランに連動します。無料プランのキーではアフィリエイトリンク（配信可のサービスのみ）、Pro プランのキーでは公式 URL を返します。いずれの場合も aiDeckUrl に AI Deck のサービスページ URL を併記します。",
    "auth": {
      "title": "認証",
      "body": "stats を除くすべてのエンドポイントで API キーが必要です。キーは Authorization ヘッダに Bearer トークンとして付与します。",
      "getKey": "設定画面の「API キー」タブでキーを発行する →"
    },
    "endpoints": {
      "title": "エンドポイント",
      "method": "メソッド",
      "path": "パス",
      "description": "内容",
      "auth": "認証",
      "authRequired": "APIキー",
      "authNone": "不要",
      "list": {
        "services": "公開サービス一覧（検索・タグ・国・並び替え・ページネーション対応）",
        "serviceDetail": "サービス詳細",
        "tags": "タグ一覧（ecosystem / function / attribute のカテゴリ付き）",
        "stats": "公開統計（総サービス数など）",
        "decks": "公開デッキ一覧",
        "deckDetail": "公開デッキ詳細"
      }
    },
    "examples": {
      "title": "リクエスト例",
      "intro": "adk_live_xxx を発行したキーに置き換えて実行してください。",
      "listLabel": "サービス一覧を検索して取得",
      "detailLabel": "サービス詳細を取得",
      "statsLabel": "統計を取得（キー不要）"
    },
    "mcp": {
      "title": "MCP サーバー",
      "intro": "カタログは MCP（Model Context Protocol）サーバーとしても公開しています。Claude・Cursor などの AI エージェントに接続すると、会話から直接 AI サービスを検索・参照できます。",
      "endpointLabel": "エンドポイント（Streamable HTTP）",
      "authNote": "API キーなしでそのまま試せます（匿名枠: 50 req/分・100 req/日、IP 単位）。Authorization: Bearer ヘッダで API キーを渡すと、キーのプランのレート枠（無料 1,000 req/日 / Pro 10,000 req/日）に拡大し、url フィールドのプラン連動も REST API と同様に適用されます。",
      "methodNote": "エンドポイントは POST のみ受け付けます（JSON-RPC over Streamable HTTP）。GET・DELETE には 405 を返します。",
      "connectTitle": "接続方法",
      "claudeAiLabel": "Claude.ai / Claude Desktop",
      "claudeAiBody": "設定の「コネクタ」から「カスタムコネクタを追加」を選び、上記エンドポイント URL を貼り付けます。",
      "cursorLabel": "Cursor（~/.cursor/mcp.json）",
      "toolsTitle": "提供ツール",
      "toolName": "ツール",
      "toolDesc": "説明",
      "toolRequires": "必要な認証",
      "requiresNone": "不要",
      "requiresKey": "API キー",
      "requiresWrite": "read_write キー",
      "tools": {
        "searchServices": "カタログを検索（キーワード・タグ・国・ソート・ページング）",
        "recommendServices": "「こんなことがしたい」の自然文から関連度順におすすめを返す（一致の強さ付き）",
        "getService": "サービス 1 件の詳細（関連リンク・ロゴ・フラグ込み）",
        "listTags": "タグ語彙の一覧（ecosystem / function / attribute のファセット別）",
        "searchDecks": "公開デッキの一覧",
        "getDeck": "公開デッキ 1 件の内容（収録サービス付き）",
        "getStats": "統計（公開サービス総数）。キー不要の接続確認にも使えます",
        "getMyDeck": "あなた自身のデッキ（エリア構成 + お気に入り）を今の状態で読み取り。プライベートメモは含まれません",
        "addToDeck": "デッキにサービスを追加。カタログを名前・URL で照合し、カタログ外は Pro ならプライベートサービスとして作成",
        "moveInDeck": "デッキ内のサービスをエリア移動・並び替え",
        "requestServiceAddition": "カタログへのサービス追加を運営にリクエスト（全プラン可）"
      },
      "scopeTitle": "キーのスコープ",
      "scopeBody": "API キーには「読み取り専用（read）」と「読み取り + 書き込み（read_write）」の 2 つのスコープがあります。デッキを書き換えるツール（add_to_deck / move_in_deck / request_service_addition）には read_write スコープのキーが必要です。スコープはキー作成時に選択し、既定は読み取り専用です。既存キーはすべて読み取り専用として扱われ、後からスコープは変更できません（read_write が必要な場合は新しいキーを作成してください）。書き込み対象は常にキー所有者自身のデッキのみです。",
      "rateNote": "レート枠は下の「レート制限」を参照してください。無効な API キーは 401 を返します（キーなしアクセスへの自動降格はしません）。"
    },
    "rateLimits": {
      "title": "レート制限",
      "intro": "レート枠はキー所有者のプランに連動します（REST・MCP 共通）。キーなしの MCP アクセスは IP 単位の匿名枠です。上限を超えると 429 を返します。",
      "plan": "プラン",
      "perMinute": "分次上限",
      "perDay": "日次上限",
      "mcpAnon": "MCP（キーなし・匿名）",
      "free": "無料",
      "pro": "Pro",
      "proNote": "Pro の枠は campaign_pro（永年 Pro）プランのキーにも適用されます。",
      "statsNote": "stats のみ API キーなしで呼べ、IP 単位の分次レート制限（{{perMinute}} req/min）が適用されます。",
      "note": "各レスポンスに X-RateLimit-Limit / X-RateLimit-Remaining / X-RateLimit-Reset ヘッダを付与します。初期値は保守的に設定しており、需要に応じて緩和する場合があります。"
    },
    "terms": {
      "title": "利用規約",
      "item1": "全件ダンプの再配布は禁止です。カタログデータをそのまま第三者に配布・転売しないでください。",
      "item2": "キャッシュの保持は 24 時間までとしてください。",
      "item3": "取得データを表示する際は AI Deck へのリンクによるクレジット表記（attribution）が必須です。",
      "item4": "アフィリエイトパラメータを改変しないでください。",
      "item5": "本 API は現状有姿で提供されます。可用性・正確性・継続提供は保証されず、仕様・レート枠・提供内容は予告なく変更または停止される場合があります。",
      "item6": "本規約は予告なく変更される場合があります。変更後も利用を継続した場合、変更に同意したものとみなします。",
      "baseTermsPrefix": "本項に定めのない事項は",
      "baseTermsSuffix": "に従います。",
      "violation": "これらの規約に違反した場合、API キーを失効することがあります。"
    },
    "compat": {
      "title": "互換性ポリシー",
      "body": "API バージョンはパス /api/public/v1 の v1 に固定されます。フィールドの追加は非破壊的な変更として予告なく行うことがあります。フィールドの削除・改名は v2 として提供し、既存バージョンを廃止する場合は可能な限り事前に告知します。"
    },
    "toc": {
      "title": "目次"
    },
    "reference": {
      "title": "API リファレンス",
      "intro": "各エンドポイントのクエリパラメータ・レスポンスフィールド・エラー・レート制限ヘッダの仕様です。値の正本はサーバー実装で、フィールドは非破壊的に追加されることがあります。",
      "common": {
        "title": "共通仕様",
        "envelopeTitle": "レスポンス封筒",
        "envelopeBody": "すべてのレスポンスは data と meta を持つ封筒に包まれます。一覧系は meta にページ情報、詳細系は meta に attribution のみを含みます。tags は meta に total を含みます。",
        "envelopeList": "一覧系（services / decks）",
        "envelopeItem": "詳細系（services/:id / decks/:id）",
        "envelopeTags": "タグ一覧（tags）",
        "envelopeStats": "統計（stats）",
        "errorsTitle": "エラー",
        "errorsNote": "エラー時は HTTP ステータスと error フィールド（文字列）を返します。500 系のメッセージ文言は将来変わりうるため、判定にはステータスコードを使ってください。",
        "headersTitle": "レート制限ヘッダ",
        "headersNote": "キー必須エンドポイントには分次ヘッダに加えて日次（-Day）ヘッダも付与されます。stats はキー不要・IP ベースのため分次ヘッダのみで、日次ヘッダは付きません。Retry-After は 429 のときだけ付きます。",
        "colName": "名前",
        "colType": "型",
        "colRequired": "必須",
        "colDefault": "既定",
        "colConstraint": "制約",
        "colDescription": "説明",
        "colNullable": "null 許容",
        "colStatus": "ステータス",
        "colBody": "レスポンス本文",
        "colHeader": "ヘッダ",
        "requiredYes": "必須",
        "requiredNo": "任意",
        "nullableYes": "○",
        "nullableNo": "—"
      },
      "params": {
        "q": "name / provider / description / descriptionEn への部分一致（大文字小文字を無視）。",
        "tags": "タグ ID のカンマ区切り。同一カテゴリ内は OR、カテゴリ間は AND で絞り込みます。未知のタグ ID は function カテゴリ扱いになります。",
        "country": "開発国コード（devCountry）の完全一致（大文字小文字を無視）。",
        "sort": "並び順。name（名前昇順）/ release_date（新しい順・null は末尾）/ popularity（お気に入り数の降順）。未指定または不正値はカタログの既定順。",
        "page": "ページ番号（1 始まり）。",
        "perPage": "1 ページあたりの件数。範囲外は 1〜100 にクランプされます。"
      },
      "pathParams": {
        "serviceId": "サービス ID（services の id と同じ値）。",
        "deckId": "デッキのスラッグ（英数・_・-・6〜32 文字）。"
      },
      "fields": {
        "service": {
          "id": "サービス ID（URL に使う一意のスラッグ）。",
          "name": "サービス名。",
          "provider": "提供元。",
          "url": "遷移先 URL。プラン連動（無料キーは配信可サービスでアフィリエイトリンク、Pro キーは公式 URL）。",
          "aiDeckUrl": "AI Deck のサービス詳細ページ URL（attribution 導線）。",
          "logoUrl": "ロゴ画像の URL またはパス。",
          "description": "日本語の説明文。",
          "descriptionEn": "英語の説明文。",
          "releaseDate": "リリース日（YYYY-MM-DD）。",
          "devCountry": "開発国コード（例: US, JP）。",
          "mcpDocsUrl": "公式 MCP ドキュメントページの URL（未確認・未提供のサービスは null）。",
          "links": "関連リンク集（home / document / github / x などのうち存在するキーのみ）。",
          "tags": "タグの配列（各要素は id / name / nameEn / category）。",
          "isEditorPick": "編集部おすすめか。",
          "isTrending": "急上昇中か。",
          "isPopular": "人気サービスか。",
          "createdAt": "AI Deck カタログへの登録日時（ISO 8601）。",
          "updatedAt": "カタログ情報の最終更新日時（ISO 8601）。"
        },
        "tag": {
          "id": "タグ ID（tags パラメータに渡す値）。",
          "name": "タグ名（日本語）。",
          "nameEn": "タグ名（英語）。",
          "category": "分類（ecosystem / function / attribute）。"
        },
        "deck": {
          "slug": "デッキのスラッグ。",
          "url": "公開デッキの URL。",
          "version": "公開バージョン。",
          "title": "デッキタイトル（未設定なら null）。",
          "description": "デッキ説明（未設定なら null）。",
          "serviceCount": "デッキに含まれるサービス数。",
          "snapshot": "デッキ構成のスナップショット（並び順・タイトル・サービス・作者などを含むオブジェクト）。",
          "publishedAt": "公開日時（ISO 8601）。",
          "updatedAt": "更新日時（ISO 8601）。"
        },
        "stats": {
          "totalServices": "公開サービスの総数。"
        }
      },
      "errors": {
        "e401": "API キーが未指定または無効。",
        "e404": "リソースが見つからない（services は Service not found、decks は Deck not found）。存在しないパスへのリクエストには Not Found を返します。",
        "e429": "レート上限（分次または日次）を超過。retryAfter（秒）と Retry-After ヘッダを併せて返します。",
        "e500": "サーバー内部エラー。"
      },
      "headers": {
        "limitMinute": "分次の上限リクエスト数。",
        "remainingMinute": "現在の分次ウィンドウの残り回数。",
        "resetMinute": "分次ウィンドウがリセットされる時刻（エポック秒）。",
        "limitDay": "日次の上限リクエスト数。",
        "remainingDay": "現在の日次ウィンドウの残り回数。",
        "resetDay": "日次ウィンドウがリセットされる時刻（エポック秒）。",
        "retryAfter": "再試行までの待機秒数（429 のときのみ）。"
      },
      "tagCategories": {
        "ecosystem": "特定のエコシステム・プラットフォーム（例: Claude Code, Hermes Agent）。",
        "function": "機能・用途（例: 画像生成, コーディング）。",
        "attribute": "提供形態・属性（例: CLI, AIエージェント, MCP）。"
      },
      "examples": {
        "title": "レスポンス例",
        "truncated": "※ data は紙面の都合で抜粋しています（一覧は件数、links・tags は一部のキーのみ）。フィールドの全量は /services のレスポンスフィールド表を参照してください。"
      },
      "labels": {
        "params": "クエリパラメータ",
        "pathParams": "パスパラメータ",
        "fields": "レスポンスフィールド",
        "example": "レスポンス例",
        "categoryMeaning": "category の意味",
        "servicesDetailNote": "data は /services の 1 要素と同じ形です。存在しない id には 404（Service not found）を返します。",
        "decksDetailNote": "スラッグが形式（英数・_・-・6〜32 文字）に合わない、または存在しない場合は 404（Deck not found）を返します。",
        "statsNote": "キー不要で呼べる唯一のエンドポイントです。IP 単位の分次レート制限（{{perMinute}} req/min）が適用されます。",
        "tagsFilterNote": "category は tags パラメータの絞り込みで、同一カテゴリ内 OR・カテゴリ間 AND の判定に使われます。",
        "backToEndpoints": "エンドポイント一覧へ戻る",
        "ref": "仕様"
      }
    }
  },
  "notFoundPage": {
    "title": "ページが見つかりません",
    "description": "お探しのページは移動または削除されたか、URL が間違っている可能性があります。",
    "backToHome": "ホームへ戻る",
    "dashboard": "ダッシュボード",
    "services": "サービス一覧"
  }
}
